export default __webpack_public_path__ + "static/media/List-documentation.d06548e1.md";